// Per-method routing decision. Default: nothing routed (behaviour unchanged).
// VITE_NOMOS_ROUTES = comma list of ApiService method names, or `*`.
// localStorage `nomos_routes` (same syntax) overrides the env for testing; empty string = route nothing.

export function parseRoutes(raw: string | null | undefined): Set<string> {
  return new Set((raw ?? '').split(',').map((s) => s.trim()).filter(Boolean));
}

export interface RouteSources { env?: string | null; local?: string | null }

export function readSources(): RouteSources {
  let env: string | undefined;
  let local: string | null = null;
  try { env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.VITE_NOMOS_ROUTES; } catch { /* none */ }
  try { local = typeof localStorage !== 'undefined' ? localStorage.getItem('nomos_routes') : null; } catch { /* blocked */ }
  return { env, local };
}

export function isRouted(method: string, src: RouteSources = readSources()): boolean {
  const raw = src.local !== null && src.local !== undefined ? src.local : src.env;
  const routes = parseRoutes(raw);
  return routes.has('*') || routes.has(method);
}
